<template>
  <el-dialog :title="`${formData.id && formData.uid ? '编辑' : '创建'}实验项目`" :visible.sync="open" width="900px" :close-on-click-modal="false" :destroy-on-close="true">
    <div class="form-div">
      <div class="form-step" style="margin-bottom:24px">
        <el-steps :active="active" simple>
          <el-step title="添加基本信息" icon="el-icon-edit"/>
          <el-step title="选择文档类型" icon="el-icon-s-order"/>
          <el-step title="编辑实验内容" icon="el-icon-upload"/>
          <el-step title="完成" icon="el-icon-finished"/>
        </el-steps>
      </div>
      <div class="form-info">
        <div class="form-data" v-if="this.active === 0">
          <el-form
            :model="formData"
            :rules="rules"
            ref="dataForm"
            label-width="80px"
          >
            <el-form-item label="实验名称" prop="expName">
              <el-input
                  v-model="formData.expName"
                  placeholder="实验名称"
              />
            </el-form-item>
            <el-form-item label="所属课程" prop="courseId">
              <el-select
                style="width: 78%;"
                v-model="formData.courseId"
                filterable
                placeholder="请选择所属课程"
              >
                <el-option v-for="course in courses" :key="course.id" :label="course.courseName" :value="course.id"/>
                <el-pagination small layout="prev, pager, next" :total="page.total" :current-page="page.page"
                               :page-size="page.limit" :pager-count="page.pagerCount" @current-change="handlePageChange"
                               hide-on-single-page/>
              </el-select>
            </el-form-item>
            <el-form-item label="实验标签" prop="expTags">
              <el-select
                style="width: 78%;"
                v-model="formData.expTags"
                filterable
                multiple
                placeholder="请选择实验标签"
              >
                <el-option
                  v-for="tag in tags"
                  :key="tag.uid"
                  :label="tag.tagName"
                  :value="tag.uid"
                >
                </el-option>
              </el-select>
            </el-form-item>
            <el-form-item label="实验类型" prop="type">
              <el-select
                style="width: 78%;"
                v-model="formData.type"
                placeholder="请选择所属课程"
              >
                <el-option
                  v-for="type in types"
                  :key="type.id"
                  :label="type.label"
                  :value="type.id"
                >
                </el-option>
              </el-select>
            </el-form-item>
          </el-form>
        </div>
        <div v-if="this.active === 1">
          <el-form
            :model="formData"
            ref="dataForm"
            :rules="rules"
            label-width="180px"
          >
            <el-form-item label="项目文档内容" prop="expContentType">
              <el-select
                style="width: 78%;"
                v-model="formData.expContentType"
                filterable
                placeholder="请选择项目内容类型"
              >
                <el-option
                    v-for="expContentType in expTypes"
                    :key="expContentType.id"
                    :label="expContentType.label"
                    :value="expContentType.id"
                    :disabled="expContentType.disabled"
                />
              </el-select>
            </el-form-item>
            <!-- <el-form-item label="是否公开" prop="isPublic">
              <el-select
                style="width: 78%;"
                v-model="formData.isPublic"
                filterable
                placeholder="请选择项目是否公开"
              >
                <el-option
                  v-for="item in pubilcStatus"
                  :key="item.id"
                  :label="item.label"
                  :value="item.id"
                ></el-option>
              </el-select>
            </el-form-item> -->
            <el-form-item label="选择软件" prop="softs">
              <el-table size="mini" :data="formData.softs" style="width: 100%">
                <el-table-column type="index"/>
                <el-table-column prop="softInfo.description" label="软件名称"/>
                <el-table-column prop="mode" label="启动模式">
                  <template slot-scope="{row}">
                    {{softModes.filter(soft => soft.value === row.mode)[0].label}}
                  </template>
                </el-table-column>
                <el-table-column prop="caseInfo.name" label="案例"/>
                <!-- <el-table-column prop="appprama.params" label="软件启动参数"></el-table-column> -->
                <el-table-column label="操作" width="76">
                  <template slot-scope="{$index}">
                    <el-button size="mini" @click="handleDel($index)" type="danger">删除</el-button>
                  </template>
                </el-table-column>
              </el-table>
              <el-button type="success" size="mini" @click="handClick" :disabled="softDisable">点击添加软件</el-button>
            </el-form-item>
            <selectsoft
              ref="selectsoftdiy"
              :courseId="formData.courseId"
              @addsoft="selectsoftadd"
            />
          </el-form>
        </div>
        <div class="form-md" v-if="this.active === 2">
          <el-form
            :model="formData"
            ref="dataForm"
            :rules="rules"
            label-width="180px"
          >
            <el-form-item label="项目内容" v-if="formData.expContentType === 2">
              <editor
                :content="formData.expContent"
                @onblur="onblur($event)"
                @onchange="setExpContent"
              />
            </el-form-item>
            <el-form-item label="上传文档" v-if="formData.expContentType === 3">
              <el-upload
                ref="upload"
                action="https://jsonplaceholder.typicode.com/posts/"
                :file-list="fileList"
                :http-request="httpRequest"
                :on-remove="removeFile"
                accept=".pdf"
              >
                <el-button size="small" type="primary">点击上传</el-button>
              </el-upload>
            </el-form-item>
          </el-form>
        </div>
      </div>
      <div class="form-footer">
        <el-button @click="handBack" v-if="this.active === 0">取消</el-button>
        <el-button @click="preStep" v-if="this.active > 0">上一步</el-button>
        <el-button type="primary" @click="nextStep" v-if="this.active < 2">下一步</el-button>
        <el-button type="primary" @click="finish" v-if="this.active === 2">提交</el-button>
      </div>
    </div>
  </el-dialog>
</template>

<script>
import { selectTagList } from '@/api/exp/exptag'
import editor from '@/components/common/editor'
import selectsoft from '@/components/select-soft.vue'
import { uploadFile } from '@/api/file'
import { duplicateCheck, add, update } from '@/api/exp/experiment'
import { getList } from '@/api/exp/course'
import { mapGetters } from 'vuex'

const EXP_EXPERIMENT = {
  type: 3,
  expContentType:2
}

export default {
  props: {
    dataForm: {
      type: Object,
      default: () => {}
    }
  },
  data() {
    const validateName = (rule, value, callback) => {
      if (value === '') {
        callback(new Error('请输入实验名称'))
      } else {
        //远程验证实验名称是否存在
        duplicateCheck({ id: this.formData.id, expName: value }).then(res => {
          if (res) {
            callback(new Error('实验名称已存在，请重新输入'))
          }
          callback()
        })
      }
    }
    return {
      open: false,
      active: 0,
      rules: {
        expName: [{ validator: validateName, trigger: 'blur' }],
        expTags: [
          { required: true, message: '请选择实验标签', trigger: 'blur' }
        ],
        courseId: [
          { required: true, message: '请选择所属课程', trigger: 'blur' }
        ],
        softs:[
           { required: true, message: '请选择实验软件', trigger: 'blur' }
        ],
      },
      page:{
          page:1,
          limit:6,
          total:0
      },
      expTypes: [
        { id: 1, label: "Markdown", disabled: true },
        { id: 2, label: '富文本' },
        { id: 3, label: '文档' }
      ],
      pubilcStatus: [
        { id: 0, label: '不公开' },
        { id: 1, label: '公开' }
      ],
      fileList: [],
      types: [
        { id: 1, label: '创造型' },
        { id: 2, label: '设计型' },
        { id: 3, label: '验证型' },
        { id: 4, label: '故障型' }
      ],
      courses: [],
      reports:[],  //报告部分
      tags: [],    //标签部分
      newArr:[],    //软件部分
      // 软件模式列表
      softModes: [
        { label: '本地启动', value: 1 },
        { label: '远程启动', value: 2 }
      ],
      cases: [], // 案例列表
      formData: {},
      expUid:'',
      value: null
    }
  },
  components: {
    editor,
    selectsoft,
  },
  computed:{
    ...mapGetters(['userInfo']),
    softDisable(){
        if(!this.formData.softs) {
            return false
        } else {
            return this.formData.softs.length === 1;
        }
    }
  },
  watch: {
    open: {
      immediate: true,
      handler: function (newVal) {
        if (newVal) {
           this.init()  //动态课程和标签
          // 打开对话框时，显示第一步
          this.active = 0
          this.formData = {
            ...EXP_EXPERIMENT,
            ...this.dataForm
          }
        } else {
          if (this.$refs['dataForm'])
            this.$refs['dataForm'].clearValidate()
          // 关闭对话框时，重置数据
          this.formData = {}
        }
      }
    },
  },
  methods: {
    init() {
    //   this.selectCourseList() //获取课程列表
      this.selectTagList() //获取实验标签列表
      this.getList()
    },
    changeVisible (visible = false) {
      this.open = visible
    },
    // 移除软件
    handleDel (index) {
      this.formData.softs.splice(index, 1);
    },
    selectsoftadd(data) {
      //选择软件之后的逻辑
      let arr = []
      if(data.id) {
        arr.push(data)
        this.$set(this.formData, 'softs', arr)
      }
    },
    onblur(info) {
      //富文本失焦相关
      this.$set(this.formData, 'expContent', info)
    },
    setExpContent(info) {
      //富文本内容发生改变相关
      this.$set(this.formData, 'expContent', info)
    },
    httpRequest(param) {
      //上传文档
        let fileObj = param.file
        const fileSuffix = fileObj.name.substring(fileObj.name.lastIndexOf(".") + 1);//限制文件上传类型
        const extension1 = fileSuffix === "pdf";
        const extension2 = (Number(fileObj.size)/1024/1024).toFixed(2) < 20 ;
        if (!extension1 || !extension2) {
            this.$message.warning('上传文件只能是pdf格式,且大小不能超过20MB!')
            this.fileList = []
        }else{
            this.uploadFile(fileObj)
            this.$refs.upload.clearFiles()
        }
    },
    removeFile() {
      //移除上传文档文件
      this.fileList = []
    },
    dataFormSubmit() {   //提交实验基本数据
      this.$refs['dataForm'].validate(valid => {
        if (valid) {
          let op = add
          if (this.formData.id && this.formData.uid) op = update
          op({
            ...this.formData,
            softs: JSON.stringify(this.formData.softs)
          }).then(res => {
            if (res) {
              this.$message.success('操作成功!');
            }else {
              this.$message.error('操作失败!');
            }
            this.formData.id = res
            this.$emit('itemChange')
          })
        }
      })
    },
    uploadFile(files) {
      //  实验指导书
      uploadFile(files, `course/${this.formData.courseId}/exp/content/`).then(res => {
        this.$set(this.formData, 'expContent', res.uid)
        if (this.fileList.length > 0) {
          this.fileList.splice(0, 1, res)
        } else {
          this.fileList.push(res)
        }
      })
    },
    handClick() {
      //点击之后弹出选择软件
      this.$nextTick(()=>{
        this.$refs.selectsoftdiy.$softaddshow()
      })
    },
    nextStep() {
      // 点击进行下一步
      this.$refs['dataForm'].validate(valid => {
        if(valid) this.active++
      })
    },
    preStep() {
      //上一步
      if (this.active > 0) this.active--
    },
    // 结束提交
    finish() {
      this.handBack()
      this.dataFormSubmit()
      this.changeVisible(false)
    },
    getList(){
        const { page, limit} = this.page
        const { userInfo } = this
        const { id } = this.$route.params
        let params = id ? { id } : { labUser: userInfo.id }
        getList(page, limit, params).then(res=>{
            const { list , totalCount } = res
            this.courses = list
            this.$set(this.page,'total',totalCount)
        })
    },
    handBack(){
        this.open = false
        this.$emit('handClose', false)
    },
    handlePageChange(page){
        this.$set(this.page, 'page', page)
        this.getList()
    },
    selectTagList() {
      //获取标签列表
      selectTagList().then(res => {
        this.tags = res.filter(tag => tag.createUser === this.userInfo.id)
      })
    },
  }
}
</script>

<style lang="less">
    .form-md{
        .w-e-text-container{
            height: 300px!important;
        }
    }
</style>
